// Adding support for Multiple Messages
define('paychex.app.messages/data/RemoteMarkMessagesReadRequest',[
    'com/paychex/widget/messageBoard/dto/MarkMessagesReadRequest',
    'com/paychex/widget/messageBoard/dto/SingleMessageRequest',
    'lodash'
], function(MarkMessagesReadRequest, SingleMessageRequest, _) {

    'use strict';

    return {
        callType: 'remote',
        operation: 'markMessagesRead',
        destination: 'messageBoardRemote',
        baseUrl: '/landing_remote/do/json/',
        objectMapperOpts: {skipDecode: true},
        generateOperationParams: function(params, data) {
            var messageRequests = new MarkMessagesReadRequest();
            messageRequests.multiMessageRequest = _.map(data, function getRequest(message) {
                var request = new SingleMessageRequest();
                request.platformMessageId = message.platformMessageId;
                request.strMessagePlatform = message.messagePlatform;
                request.strUserGuid = null;
                request.messageId = message.messageId;
                return request;
            });
            return messageRequests;
        }
    };
});

// ///////////////////////Code for Single Message read /////////////////////
/* define([
        'com/paychex/widget/messageBoard/dto/MarkMessageReadRequest'
    ], function(MarkMessageReadRequest)
    {
        'use strict';

        return {
            callType: 'remote',
            operation: 'markMessageRead',
            destination: 'MessageBoardRemote',
            baseUrl: '/landing_remote/do/json/',
            generateOperationParams: function(message) {
                var request = new MarkMessageReadRequest();
                request.platformMessageId = message.platformMessageId;
                request.strMessagePlatform = message.messagePlatform;
                request.strUserGuid = null;
                request.messageId = message.messageId;
                return request;
            },
            transformResponse: function(response) {
                return response;
            }
        };
    }
);
    */
;
